<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-avatar v-on="on" size="26" :color="iconColor">
        <v-icon dark small>
          mdi-{{ icon }}
        </v-icon>
      </v-avatar>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'cdrs-rec-icon',
  computed: {
    iconColor: function () {
      if (this.rec.isFailed) {
        return 'red'
      }
      return this.rec.isInbound
        ? 'teal'
        : 'primary'
    },
    icon: function () {
      return this.rec.isInbound
        ? 'call-received'
        : 'call-made'
    },
    tooltip: function () {
      let msg
      if (this.rec.isInbound) {
        msg = this.$t('cdrs.tip.incoming')
      } else {
        msg = this.$t('cdrs.tip.outgoing')
      }
      if (this.rec.isFailed) {
        msg += ' ' + this.$t('cdrs.tip.failed')
      }
      return msg
    }
  },
  props: {
    rec: {
      type: Object
    }
  }
}
</script>

<style scoped>
</style>
